// ISO31000Certification.jsx
import React from "react";

export default function ISO31000Certification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISO 31000 Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISO 31000 Risk Management Certification Support
          </h1>
          <div className="w-20 h-1 bg-sky-600 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports ISO 31000‑based Certification for risk
            management systems, helping organisations design frameworks and
            processes aligned with ISO 31000:2018 principles, framework, and
            process.[web:389][web:396]
          </p>
          <p className="text-gray-700">
            The service focuses on embedding structured risk management into
            strategy and operations so that risks are identified, analysed,
            evaluated, and treated consistently across the business.[web:389][web:398]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-sky-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/7567446/pexels-photo-7567446.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team analysing risk charts and reports"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISO 31000‑Based Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Bodies certifying against ISO 31000‑aligned risk systems typically
              review the organisation’s risk framework, policies, and supporting
              governance and process records.[web:394][web:395]
            </p>
            <div className="bg-gray-50 border border-sky-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Risk management framework documentation setting out mandate
                  and commitment, roles and responsibilities, integration with
                  governance, and the cycle for design, implementation, review,
                  and improvement.[web:389][web:396]
                </li>
                <li>
                  Policy documents such as an enterprise risk management policy,
                  appetite/tolerance statements, and supporting procedures and
                  guidelines for identification, assessment, treatment,
                  monitoring, and reporting.[web:394][web:398]
                </li>
                <li>
                  Company details and organisational context, including
                  corporate registration, organisational chart, strategic
                  objectives, and description of key activities and stakeholders
                  relevant to risk.[web:396][web:399]
                </li>
                <li>
                  Operational risk records like risk registers, assessment
                  reports, treatment plans, incident/near‑miss logs, monitoring
                  reports, and review or oversight committee minutes.[web:394][web:401]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The objective is to create a practical, enterprise‑wide risk
              framework that satisfies certification criteria while supporting
              better decision‑making.[web:398][web:401]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-sky-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Risk Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on applying ISO 31000 principles to your governance
                  and processes, including tailoring the framework to industry,
                  size, and regulatory context.[web:389][web:396]
                </p>
              </div>

              <div className="border-l-4 border-sky-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in structuring risk manuals, policies, registers, and
                  evidence so they clearly demonstrate conformity with
                  ISO‑aligned criteria during audits.[web:394][web:395][web:401]
                </p>
              </div>

              <div className="border-l-4 border-sky-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory from initial framework design through internal
                  assessments and external certification, helping maintain and
                  continually improve risk management practices.[web:397][web:398]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-sky-600 text-sky-700 font-medium hover:bg-sky-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
